export default __webpack_public_path__ + "static/signal-4db0dc1f0a048573167c3c6c3b959770.png";